import React, { useState } from 'react';
import { useDispatch } from "react-redux";
import { updateUserPassword } from "./../../../../services/global_redux/globale_actions/Login.action"
import {updateVendorPassword} from '../../../../services/audit_redux/audit_actions/vendor.action';
import { useNavigate } from "react-router-dom";
function ChangePassword({ showSnackbar, setLoading }) {

  const navigate = useNavigate();
    const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  const [showCriteria, setShowCriteria] = useState(false);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));

    if (id === 'newPassword') {
      setShowCriteria(true);
    }
  };


  const discardChanges = () => {
    setFormData({
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
    });
    setShowCriteria(false);
  };

  const validatePassword = (password) => {
    const hasUppercase = /[A-Z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const isLongEnough = password.length >= 8;
    return {
      hasUppercase,
      hasNumber,
      isLongEnough,
      isValid: hasUppercase && hasNumber && isLongEnough,
    };
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { newPassword, confirmPassword ,currentPassword} = formData;
    const { isValid } = validatePassword(newPassword);
    if (!isValid) {
      showSnackbar('Please Enter Strong password.', "error");
      return;
    }else if (newPassword !== confirmPassword) {
      showSnackbar('Passwords do not match.', "error");
      return;
    }else if(newPassword === currentPassword){
        showSnackbar('New passwords should not be same as current password.', "error");
        return;
    }else{
        updateUserNewPassword();
    }


  };

  const updateUserNewPassword = async () =>{
    try {
        // setLoading(true);
        const current_role = JSON.parse(sessionStorage.getItem('user'));
        console.log(current_role.base_role);
        const finalData = {
            "old_password":formData.currentPassword,
            "new_password":formData.newPassword
        }
        let response;  // <-- Declare here

        if (current_role.base_role === 'vendor') {
          response = await dispatch(updateVendorPassword(finalData));
        } else {
          response = await dispatch(updateUserPassword(finalData));
        }
        if(response.success === true){
            showSnackbar(response.message, "success");
            navigate("/dashboard");
        }else{
            showSnackbar(response.message, "error");
        }
        setLoading(false);
    } catch (error) {
        showSnackbar("An error occurred", "error");
        setLoading(false);
    }
  }
  const { newPassword } = formData;
  const { hasUppercase, hasNumber, isLongEnough } = validatePassword(newPassword);

  return (
    <div className="d-flex justify-content-center align-items-center bg-transparent" style={{ minHeight: '90vh' }}>
      
      <div className="card p-4 shadow rounded" style={{ maxWidth: '400px', width: '100%' }}>
        <div className="d-flex align-items-center mb-3">
          <h5 className="mb-0">Change Password</h5>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="currentPassword" className="form-label">
              Current Password *
            </label>
            <input
              type="password"
              className="form-control"
              id="currentPassword"
              required
              value={formData.currentPassword}
              onChange={handleChange}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="newPassword" className="form-label">
              New Password *
            </label>
            <input
              type="password"
              className="form-control"
              id="newPassword"
              required
              value={formData.newPassword}
              onChange={handleChange}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="confirmPassword" className="form-label">
              Confirm New Password *
            </label>
            <input
              type="password"
              className="form-control"
              id="confirmPassword"
              required
              value={formData.confirmPassword}
              onChange={handleChange}
            />
            {/* <button
              type="button"
              className="btn btn-link btn-sm p-0 mt-1"
              onClick={clearConfirmPassword}
            >
              Clear
            </button> */}
          </div>

          {showCriteria && (
            <div className="mb-3 small">
              <p className={hasUppercase && hasNumber && isLongEnough ? 'text-success' : 'text-danger'}>
                {hasUppercase && hasNumber && isLongEnough ? 'Strong password!' : 'Weak password. Must contain:'}
              </p>
              <ul className="mb-0 ps-3">
                <li className={hasUppercase ? 'text-success' : 'text-muted'}>At least 1 uppercase</li>
                <li className={hasNumber ? 'text-success' : 'text-muted'}>At least 1 number</li>
                <li className={isLongEnough ? 'text-success' : 'text-muted'}>At least 8 characters</li>
              </ul>
            </div>
          )}

          <div className="d-flex justify-content-between">
            <a
                href='/dashboard'
                className="btn btn-secondary"
                onClick={discardChanges}
            >
              Close
            </a>
            <button type="submit" className="btn btn-primary">
              Changes
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePassword;
